module.exports = "../dist/img/white-32.9b8c.jpg";